import { Injectable } from '@angular/core';
import { Language, language } from '@models/settings';
import { TranslateService } from '@ngx-translate/core';
import 'dayjs/locale/en';
import 'dayjs/locale/ja';
import dayjs from 'dayjs';

@Injectable({ providedIn: 'root' })
export class LanguageService {
    readonly LOCAL_STORAGE_KEY: string = 'icreate-language-setting';

    private browserLanguage: string;
    private localStorageLanguage: string;

    public selectedLanguage: string;

    constructor(private translateService: TranslateService) {}

    initializeLanguage() {
        this.localStorageLanguage = localStorage.getItem(this.LOCAL_STORAGE_KEY);

        if (!this.localStorageLanguage) {
            const browserLanguage = navigator.language;
            const findIndex = language.findIndex(lan => lan.value.includes(browserLanguage));
            this.browserLanguage = findIndex === -1 ? language[0].value : browserLanguage;

            this.selectedLanguage = this.browserLanguage;
        } else {
            this.selectedLanguage = this.localStorageLanguage;
        }

        this.translateService.use(this.selectedLanguage);
    }

    setLocalStorageLanguage(language: Language) {
        localStorage.setItem(this.LOCAL_STORAGE_KEY, language);
        this.localStorageLanguage = localStorage.getItem(this.LOCAL_STORAGE_KEY);
        this.selectedLanguage = this.localStorageLanguage;

        this.translateService.use(this.selectedLanguage);
        dayjs.locale(language);
    }

    getLanguage() {
        return this.selectedLanguage;
    }
}
